export default __webpack_public_path__ + "static/media/kitchen5-afterD-480w.b93d00de.png";